import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CronJobService } from '../../../api/services';
import { cronJobActions } from './cronJob.actions';
import { concatMap, delay } from 'rxjs';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';
import { mapResponse } from '@ngrx/operators';
import { LoadingState } from '../models/loader.model';

export const cronJobLoadEffect = createEffect(
  (actions$ = inject(Actions), cronJobService = inject(CronJobService)) => {
    return actions$.pipe(
      ofType(cronJobActions.loadCronJobList),
      concatMap((props) =>
        cronJobService.cronJobControllerFind(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) =>
              cronJobActions.loadCronJobListDone({
                data: r.data,
                state: { value: LoadingState.SUCCESS },
                request: props,
              }),
            error: (error: ZetraError) =>
              cronJobActions.loadCronJobListDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
